export default __webpack_public_path__ + "5d1a86aca7977772b115abfc27bfb75c.svg";